import React from "react";
import { useIntl } from "react-intl";
import { HomeV2 } from "@piiqtechnologies/svg-icons";
import { PeekDivider, PeekList, PeekPaper, PeekStack } from "@piiqtechnologies/ui-components";
import { AnalyticsArea, useHomeDestination, useTrackEvent } from "@hooks";
import { NavigationLogo, OrganizationSwitcher } from "../navigation-bar";
import { CommunityList, SIDEBAR_ICON_SIZE, SidebarFooter, SidebarPageItem } from "./components";
import messages from "./messages.i18n";
export const SIDEBAR_WIDTH = 200;
export const AppSidebar = () => {
    const intl = useIntl();
    const track = useTrackEvent();
    const homeDestination = useHomeDestination();
    return (React.createElement(PeekPaper, { elevation: 0, sx: {
            top: 0,
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            height: "100%",
            position: "sticky",
        } },
        React.createElement(PeekStack, { sx: { px: 1, py: 2, overflow: "hidden" }, height: "-webkit-fill-available", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "column", gap: 1, sx: { flex: 1, minHeight: 0 } },
                React.createElement(NavigationLogo, null),
                React.createElement(OrganizationSwitcher, null),
                React.createElement(PeekDivider, { orientation: "horizontal", light: true }),
                React.createElement(PeekList, { disablePadding: true },
                    React.createElement(SidebarPageItem, { label: intl.formatMessage(messages.appSidebarHome), icon: React.createElement(HomeV2, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE }), to: homeDestination, onClick: () => track(AnalyticsArea.Navigation, "Portfolio Overview Clicked") })),
                React.createElement(CommunityList, null)),
            React.createElement(SidebarFooter, null))));
};
export default AppSidebar;
